export const urgentisteMasqueTranslations = {
  fr: {
    pageTitle: "L'Urgentiste masqué",
    heroTitle: "Les cas cliniques de l'Urgentiste masqué",
    heroDescription: "Des cas cliniques réels issus des réseaux sociaux, analysés et commentés par des professionnels",
    badgeEmergency: "Médecine d'urgence",
    badgeReal: "Cas réels",
    followLabel: "Suivez l'Urgentiste masqué :",
    availableCases: "Cas cliniques disponibles",
    exploreCases: "Explorez des cas cliniques authentiques et leurs prises en charge détaillées",
    searchPlaceholder: "Rechercher par mot-clé, tag ou pathologie...",
    casesFound: "{{count}} cas trouvé(s) pour \"{{term}}\"",
    analyzeCase: "Analyser le cas",
    comingSoonTitle: "Nouveaux cas à venir",
    comingSoonDescription: "D'autres cas cliniques seront ajoutés régulièrement",
    noCasesFound: "Aucun cas trouvé",
    noCasesHint: "Essayez avec d'autres mots-clés comme \"SCA\", \"urgence\", \"cardiaque\"...",
    clearFilters: "Réinitialiser les filtres",
    caseNotFound: "Cas non trouvé",
    backToCases: "Retour aux cas cliniques",
    prevCase: "Préc.",
    nextCase: "Suiv.",
    caseLabel: "Cas",
    caseOf: "Cas {{current}} / {{total}}",
    tabPresentation: "Présentation",
    tabPresentationShort: "Cas",
    tabAnalysis: "Analyse",
    tabResponse: "Réponse",
    tabResponseShort: "Résul.",
    presentationTitle: "Présentation du cas",
    medicalImage: "Image médicale",
    questionsTitle: "Questions à analyser",
    keyPoints: "Points clés à retenir",
    expertResponse: "Réponse de l'Urgentiste masqué",
    management: "Prise en charge réalisée",
    aboutCase: "À propos de ce cas",
    difficulty: "Difficulté",
    specialties: "Spécialités",
    estimatedDuration: "Durée estimée",
    similarCases: "Cas similaires",
    totalCases: "{{count}} cas disponibles",
    filterAll: "Tous",
    filterBeginner: "Débutant",
    filterIntermediate: "Intermédiaire",
    filterAdvanced: "Avancé",
    filterExpert: "Expert",
    clickToReveal: "Cliquez pour révéler",
    hideAnswer: "Masquer",
    questionNumber: "Question {{number}}",
    selfAssessLabel: "Auto-évaluation : aviez-vous la réponse ?",
    assessKnew: "Je savais",
    assessPartial: "Partiellement",
    assessMissed: "Je ne savais pas",
    seeExpertAnswer: "Voir la réponse de l'expert",
    assessmentDone: "Auto-évaluation terminée",
    ecgLabel: "ECG - Cas {{num}}",
    quizCompleted: "Quiz terminé !",
    quizProgress: "complété",
    revealAndAssess: "Révéler et m'auto-évaluer",
    assessmentRecorded: "Réponse enregistrée",
    nextQuestion: "Question suivante",
    finishQuiz: "Terminer le quiz",
    restart: "Recommencer",
    feedbackExcellent: "Excellent travail ! Vous maîtrisez bien ce sujet.",
    feedbackGood: "Bon travail ! Quelques points à approfondir.",
    feedbackRetry: "Continuez à réviser ce sujet pour progresser.",
  },
  en: {
    pageTitle: "The Masked ER Doctor",
    heroTitle: "Clinical cases from the Masked ER Doctor",
    heroDescription: "Real clinical cases from social media, analyzed and commented by professionals",
    badgeEmergency: "Emergency medicine",
    badgeReal: "Real cases",
    followLabel: "Follow the Masked ER Doctor:",
    availableCases: "Available clinical cases",
    exploreCases: "Explore authentic clinical cases and their detailed management",
    searchPlaceholder: "Search by keyword, tag or pathology...",
    casesFound: "{{count}} case(s) found for \"{{term}}\"",
    analyzeCase: "Analyze the case",
    comingSoonTitle: "New cases coming soon",
    comingSoonDescription: "More clinical cases will be added regularly",
    noCasesFound: "No cases found",
    noCasesHint: "Try other keywords like \"ACS\", \"emergency\", \"cardiac\"...",
    clearFilters: "Clear filters",
    caseNotFound: "Case not found",
    backToCases: "Back to clinical cases",
    prevCase: "Prev.",
    nextCase: "Next",
    caseLabel: "Case",
    caseOf: "Case {{current}} / {{total}}",
    tabPresentation: "Presentation",
    tabPresentationShort: "Case",
    tabAnalysis: "Analysis",
    tabResponse: "Response",
    tabResponseShort: "Resp.",
    presentationTitle: "Case presentation",
    medicalImage: "Medical image",
    questionsTitle: "Questions to analyze",
    keyPoints: "Key points to remember",
    expertResponse: "The Masked ER Doctor's response",
    management: "Management performed",
    aboutCase: "About this case",
    difficulty: "Difficulty",
    specialties: "Specialties",
    estimatedDuration: "Estimated duration",
    similarCases: "Similar cases",
    totalCases: "{{count}} cases available",
    filterAll: "All",
    filterBeginner: "Beginner",
    filterIntermediate: "Intermediate",
    filterAdvanced: "Advanced",
    filterExpert: "Expert",
    clickToReveal: "Click to reveal",
    hideAnswer: "Hide",
    questionNumber: "Question {{number}}",
    selfAssessLabel: "Self-assessment: did you know the answer?",
    assessKnew: "I knew it",
    assessPartial: "Partially",
    assessMissed: "I didn't know",
    seeExpertAnswer: "See expert answer",
    assessmentDone: "Self-assessment complete",
    ecgLabel: "ECG - Case {{num}}",
    quizCompleted: "Quiz completed!",
    quizProgress: "completed",
    revealAndAssess: "Reveal and self-assess",
    assessmentRecorded: "Answer recorded",
    nextQuestion: "Next question",
    finishQuiz: "Finish quiz",
    restart: "Restart",
    feedbackExcellent: "Excellent work! You've mastered this topic.",
    feedbackGood: "Good work! A few points to review.",
    feedbackRetry: "Keep studying this topic to improve.",
  },
  es: {
    pageTitle: "El Urgenciólogo enmascarado",
    heroTitle: "Casos clínicos del Urgenciólogo enmascarado",
    heroDescription: "Casos clínicos reales de redes sociales, analizados y comentados por profesionales",
    badgeEmergency: "Medicina de urgencias",
    badgeReal: "Casos reales",
    followLabel: "Sigue al Urgenciólogo enmascarado:",
    availableCases: "Casos clínicos disponibles",
    exploreCases: "Explora casos clínicos auténticos y su manejo detallado",
    searchPlaceholder: "Buscar por palabra clave, etiqueta o patología...",
    casesFound: "{{count}} caso(s) encontrado(s) para \"{{term}}\"",
    analyzeCase: "Analizar el caso",
    comingSoonTitle: "Nuevos casos próximamente",
    comingSoonDescription: "Se añadirán más casos clínicos regularmente",
    noCasesFound: "No se encontraron casos",
    noCasesHint: "Prueba con otras palabras clave como \"SCA\", \"urgencia\", \"cardíaco\"...",
    clearFilters: "Limpiar filtros",
    caseNotFound: "Caso no encontrado",
    backToCases: "Volver a los casos clínicos",
    prevCase: "Ant.",
    nextCase: "Sig.",
    caseLabel: "Caso",
    caseOf: "Caso {{current}} / {{total}}",
    tabPresentation: "Presentación",
    tabPresentationShort: "Caso",
    tabAnalysis: "Análisis",
    tabResponse: "Respuesta",
    tabResponseShort: "Resp.",
    presentationTitle: "Presentación del caso",
    medicalImage: "Imagen médica",
    questionsTitle: "Preguntas para analizar",
    keyPoints: "Puntos clave a recordar",
    expertResponse: "Respuesta del Urgenciólogo enmascarado",
    management: "Manejo realizado",
    aboutCase: "Sobre este caso",
    difficulty: "Dificultad",
    specialties: "Especialidades",
    estimatedDuration: "Duración estimada",
    similarCases: "Casos similares",
    totalCases: "{{count}} casos disponibles",
    filterAll: "Todos",
    filterBeginner: "Principiante",
    filterIntermediate: "Intermedio",
    filterAdvanced: "Avanzado",
    filterExpert: "Experto",
    clickToReveal: "Clic para revelar",
    hideAnswer: "Ocultar",
    questionNumber: "Pregunta {{number}}",
    selfAssessLabel: "Autoevaluación: ¿sabías la respuesta?",
    assessKnew: "Lo sabía",
    assessPartial: "Parcialmente",
    assessMissed: "No lo sabía",
    seeExpertAnswer: "Ver respuesta del experto",
    assessmentDone: "Autoevaluación completada",
    ecgLabel: "ECG - Caso {{num}}",
    quizCompleted: "¡Quiz completado!",
    quizProgress: "completado",
    revealAndAssess: "Revelar y autoevaluarme",
    assessmentRecorded: "Respuesta registrada",
    nextQuestion: "Siguiente pregunta",
    finishQuiz: "Terminar quiz",
    restart: "Reiniciar",
    feedbackExcellent: "¡Excelente trabajo! Dominas bien este tema.",
    feedbackGood: "¡Buen trabajo! Algunos puntos por profundizar.",
    feedbackRetry: "Sigue estudiando este tema para mejorar.",
  },
};
